<template>
  <div>
    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-bus-multiple </v-icon>
        <span class="pl-2">{{ $t('pages.buses') }}</span>
        <v-spacer></v-spacer>
        <create-button @create="showBusDialog"></create-button>
      </v-card-title>
      <v-data-table
        item-key="id"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :headers="headers"
        :items="buses"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:item.students="{ item }">
          <template v-if="!$isDirector">
          <v-icon small class="mr-2" @click="assignStudents(item)">
            mdi-account-multiple-plus
          </v-icon>
          <v-icon small class="mr-2" @click="assignStudentsOrder(item)">
            mdi-account-multiple
          </v-icon>
          </template>
        </template>
        <template v-slot:item.drivers="{ item }">
          <div v-if="item.drivers.length > 0">
            <v-chip
              v-for="driver in item.drivers"
              :key="driver.id"
              :color="getDriverAssignmentColor(driver)"
              dark
            >
              <!--              @click="assignDriver(driver)"-->
              {{ getDriver(driver) }}
            </v-chip>
          </div>
          <v-chip v-else :color="getDriverAssignmentColor()" dark>
            <!--            @click="assignDriver()"-->
            {{ getDriver() }}
          </v-chip>
        </template>
        <!--        <template v-slot:item.created_at="{ item }">-->
        <!--          <small>{{ item.created_at | moment('LL') }}</small> - -->
        <!--          <small class="text-muted">{{ item.created_at | moment('LT') }}</small>-->
        <!--        </template>-->
        <template v-slot:item.actions="{ item }">
          <template v-if="!$isDirector">
          <v-btn v-if="item.driver" icon x-small color="error" class="mr-1" @click="unAssignDriver(item)">
            <v-icon small>mdi-account-off</v-icon>
          </v-btn>
          <v-btn v-else icon x-small color="info" class="mr-1" @click="assignDriver(item)">
            <v-icon small>mdi-account-tie-hat</v-icon>
          </v-btn>
          </template>
          <v-btn v-if="!$isDirector" icon x-small color="warning" class="mr-1" @click="editBus(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn v-if="!$isDirector" icon x-small color="error" @click="deleteBus(item, buses.indexOf(item))">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="busDialog" persistent max-width="600px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ $t('pages.bus_data') }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="name"
                      :rules="nameRules"
                      :label="$t('forms.name') + '*'"
                      :hint="$t('forms.name_of_the_bus')"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="license"
                      :rules="licenseRules"
                      :label="$t('forms.license_plate') + '*'"
                      :hint="$t('forms.license_plate_of_the_bus')"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="capacity"
                      :rules="capacityRules"
                      :label="$t('forms.capacity') + '*'"
                      :hint="$t('forms.number_of_seats_in_the_bus')"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="busDialog = false">
                {{ $t('actions.close') }}
              </v-btn>
              <v-btn color="blue darken-1" text @click="createBus">
                {{ $t('actions.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
    <v-dialog v-if="selectedBus" v-model="driversDialog" max-width="390">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t('pages.select_driver_for') }} '{{ selectedBus.name }}'
        </v-card-title>
        <v-card-text>
          <v-list dense>
            <v-subheader>{{ $t('pages.drivers') }}</v-subheader>
            <!--            <v-list-item-group>-->
            <!--              <v-list-item v-for="(driver, i) in availableDrivers" :key="i">-->
            <!--                <v-list-item-content>-->
            <!--                  <v-list-item-title-->
            <!--                    v-text="driver.name"-->
            <!--                    @click="assignDriverToBus(driver)"-->
            <!--                  ></v-list-item-title>-->
            <!--                </v-list-item-content>-->
            <!--              </v-list-item>-->
            <!--            </v-list-item-group>-->
          </v-list>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-show="!loadingDrivers"
                v-model="selectedDrivers"
                :items="availableDrivers"
                item-text="name"
                item-value="id"
                clearable
                dense
                chips
                :label="$t('forms.select')"
                multiple
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-container style="min-height: 200px; max-height: 400px">
          <v-row
            v-show="loadingDrivers"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col class="text-subtitle-1 text-center" cols="12">
              Please wait ...
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                :active="loadingDrivers"
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeDriverDialog">
            {{ $t('actions.close') }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="assignDriverToBus">
            {{ $t('actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="selectedBus" v-model="studentsDialog" max-width="390">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t('pages.select_students_for') }} '{{ selectedBus.name }}'
        </v-card-title>
        <v-container style="height: 400px">
          <v-card-text>
            <v-list dense>
              <v-subheader>{{ $t('pages.students') }}</v-subheader>
            </v-list>
          </v-card-text>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-show="!loadingStudents"
                  v-model="selectedStudents"
                  :items="availableStudents"
                  item-text="name"
                  item-value="id"
                  clearable
                  dense
                  chips
                  :label="$t('forms.select')"
                  multiple
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index >= 0 && index < 5">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 5" class="grey--text text-caption">
                      (+{{ selectedStudents.length - 5 }}
                      {{ $t('forms.others') }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row
            v-show="loadingStudents"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col class="text-subtitle-1 text-center" cols="12">
              Please wait ...
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                :active="loadingStudents"
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeStudentsDialog">
            {{ $t('actions.close') }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="assignStudentsToBus">
            {{ $t('actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="selectedBus" v-model="studentsOrderDialog" max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t('pages.change_order_students_for') }} '{{ selectedBus.name }}'
        </v-card-title>
        <v-container style="height: 700px; overflow: scroll">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-list dense max-height="400">
                  <v-subheader>{{ $t('pages.students') }}</v-subheader>
                  <v-list-item-group color="primary" v-if="studentsOrderDialog">
                    <draggable v-model="selectedStudents">
                      <transition-group>
                        <v-list-item
                          v-for="(student, i) in selectedStudents"
                          :key="student.id"
                          style="cursor: move"
                        >
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="i + 1 + '. ' + student.name"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </transition-group>
                    </draggable>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row
            v-show="loadingStudents"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col class="text-subtitle-1 text-center" cols="12">
              Please wait ...
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                :active="loadingStudents"
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeStudentsOrderDialog">
            {{ $t('actions.close') }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="orderStudentsToBus">
            {{ $t('actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CreateButton from '@/components/CreateButton';
import { mesazhiIGabimit } from '@/utils/error-message';
import draggable from 'vuedraggable';

export default {
  components: {
    CreateButton,
    draggable,
  },
  data() {
    return {
      buses: [],
      availableDrivers: [],
      isLoading: false,
      search: '',
      busDialog: false,
      driversDialog: false,
      loadingDrivers: false,
      valid: true,
      id: null,
      selectedBus: null,
      selectedDrivers: [],
      name: '',
      nameRules: [
        (v) => !!v || this.$t('forms.name_is_required'),
        (v) =>
          (v && v.length <= 255) ||
          this.$t('forms.name_must_be_less_than_255_characters'),
      ],
      license: '',
      licenseRules: [(v) => !!v || this.$t('forms.license_plate_is_required')],
      capacity: '',
      capacityRules: [
        (v) => /^[0-9]+$/.test(v) || this.$t('forms.capacity_is_not_valid'),
      ],
      headers: [
        // { text: this.$t('table.id'), value: 'id', align: 'start', filterable: false },
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('table.students'), value: 'students' },
        { text: this.$t('table.license'), value: 'license' },
        { text: this.$t('table.capacity'), value: 'capacity' },
        { text: this.$t('table.drivers'), value: 'drivers' },
        // { text: this.$t('table.created'), value: 'created_at' },
        { text: this.$t('table.actions'), value: 'actions', sortable: false },
      ],
      studentsDialog: false,
      loadingStudents: false,
      availableStudents: [],
      selectedStudents: [],
      studentsOrderDialog: false,
    };
  },
  mounted() {
    this.loadBuses();
  },
  methods: {
    loadBuses() {
      this.isLoading = true;
      this.buses = [];
      axios
        .get(`/buses/all`)
        .then((response) => {
          this.buses = response.data;
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_retrieving'),
            type: 'error',
          });
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    validate() {
      return this.$refs.form.validate();
    },
    createBus() {
      if (this.validate()) {
        this.isLoading = true;
        this.busDialog = false;
        axios
          .post(`/buses/create-edit`, {
            bus: {
              id: this.id,
              name: this.name,
              license: this.license,
              capacity: this.capacity,
            },
          })
          .then(() => {
            this.loadBuses();
            this.$notify({
              title: this.$t('messages.success'),
              text: this.id
                ? this.$t('messages.updated')
                : this.$t('messages.created'),
              type: 'success',
            });
            // this.$swal(
            //   this.$t('messages.success'),
            //   this.id ? this.$t('messages.updated') : this.$t('messages.created'),
            //   'success'
            // );
          })
          .catch(() => {
            this.$notify({
              title: this.$t('messages.error'),
              text: this.$t('messages.error_while_creating'),
              type: 'error',
            });
            // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    showBusDialog() {
      this.id = null;
      this.$refs.form?.reset();
      this.busDialog = true;
    },
    editBus(bus) {
      this.id = bus.id;
      this.name = bus.name;
      this.license = bus.license;
      this.capacity = bus.capacity;
      this.busDialog = true;
    },
    deleteBus(bus, index) {
      this.$swal
        .fire({
          title: this.$t('actions.delete'),
          text:
            this.$t('messages.are_you_sure_to_delete_the') +
            " ' " +
            bus.name +
            " ' ? " +
            this.$t('messages.you_wont_be_able_to_revert_this') +
            '!',
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: this.$t('actions.yes_delete_it'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteBusServer(bus.id, index);
          }
        });
    },
    deleteBusServer(bus_id, index) {
      axios
        .delete(`/buses/${bus_id}`)
        .then(() => {
          this.buses.splice(index, 1);
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.deleted'),
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_deleting'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          //this.isDeleting = false;
        });
    },
    getDriverAssignmentColor(driver) {
      if (driver) return 'success';
      else return 'error';
    },
    getDriver(driver) {
      if (driver) return driver.name;
      else return 'none';
    },
    assignDriver(item) {
      const driversId = item?.drivers?.map(({ id }) => id);
      this.selectedBus = item;
      this.driversDialog = true;
      this.selectedDrivers = driversId;
      this.loadAvailableDrivers();
    },
    loadAvailableDrivers() {
      this.loadingDrivers = true;
      this.availableDrivers = [];
      axios
        .get('/buses/available-drivers')
        .then((response) => {
          this.availableDrivers = response.data;
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_retrieving'),
            type: 'error',
          });
          // this.$swal(
          //   this.$t('messages.error'),
          //   error.response.data.message,
          //   'error'
          // );
        })
        .then(() => {
          this.loadingDrivers = false;
        });
    },
    assignDriverToBus() {
      this.loadingDrivers = true;
      axios
        .post(`/buses/assign-drivers`, {
          bus_id: this.selectedBus.id,
          drivers_ids: this.selectedDrivers,
        })
        .then(() => {
          this.loadBuses();
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.assigned') + '!',
            type: 'success',
          });
          // this.$swal(
          //   'Success',
          //   'Drivers assigned to bus successfully',
          //   'success'
          // );
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_assigning'),
            type: 'error',
          });
          // this.$swal(
          //   this.$t('messages.error'),
          //   error.response.data.message,
          //   'error'
          // );
        })
        .then(() => {
          this.loadingDrivers = false;
          this.closeDriverDialog();
        });

      // this.loadingDrivers = true;
      // axios
      //   .post(`/buses/assign-driver`, {
      //     bus_id: this.selectedBus.id,
      //     driver_id: driver.id,
      //   })
      //   .then((response) => {
      //     this.loadBuses();
      //     this.$notify({
      //       title: 'Success',
      //       text: 'Driver assigned to bus!',
      //       type: 'success',
      //     });
      //     this.$swal(
      //       'Success',
      //       'Driver assigned to bus successfully',
      //       'success'
      //     );
      //   })
      //   .catch((error) => {
      //     this.$notify({
      //       title: 'Error',
      //       text: mesazhiIGabimit(error),
      //       type: 'error',
      //     });
      //     this.$swal('Error', error.response.data.message, 'error');
      //   })
      //   .then(() => {
      //     this.loadingDrivers = false;
      //     // this.closeDriverDialog();
      //   });
    },
    unAssignDriver(item) {
      this.$swal
        .fire({
          title: 'Un-assign driver from bus',
          text:
            "Are you sure to un-assign the driver ' " +
            item.driver.name +
            " ' from the bus '" +
            item.name +
            "' ? You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.unAssignDriverFromBus(item);
          }
        });
    },
    unAssignDriverFromBus(item) {
      this.isLoading = true;
      axios
        .post(`/buses/unassign-driver`, {
          bus_id: item.id,
        })
        .then(() => {
          this.loadBuses();
          this.$notify({
            title: 'Success',
            text: 'Driver unassigned from bus!',
            type: 'success',
          });
          this.$swal(
            'Success',
            'Driver unassigned from bus successfully',
            'success'
          );
        })
        .catch((error) => {
          this.$notify({
            title: 'Error',
            text: mesazhiIGabimit(error),
            type: 'error',
          });
          this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    closeDriverDialog() {
      this.driversDialog = false;
      this.loadingDrivers = false;
      this.availableDrivers = [];
      this.selectedDrivers = [];
    },
    closeStudentsDialog() {
      this.studentsDialog = false;
      this.loadingStudents = false;
      this.availableStudents = [];
      this.selectedStudents = [];
    },
    loadAvailableStudents() {
      this.loadingStudents = true;
      this.availableStudents = [];
      axios
        .get('/users/all-students-list')
        .then((response) => {
          this.availableStudents = response.data;
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: mesazhiIGabimit(error),
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.loadingStudents = false;
        });
    },
    assignStudents(item) {
      this.loadAvailableStudents();
      const studentsId = item?.students?.map(({ id }) => id);
      this.selectedBus = item;
      this.selectedStudents = studentsId;
      this.studentsDialog = true;
    },
    assignStudentsToBus() {
      this.loadingStudents = true;
      axios
        .post(`/buses/assign-students`, {
          bus_id: this.selectedBus.id,
          students_ids: this.selectedStudents,
        })
        .then(() => {
          this.loadBuses();
          this.$notify({
            title: this.$t('messages.success'),
            text: 'Students assigned to bus!',
            type: 'success',
          });
          // this.$swal(
          //   'Success',
          //   'Students assigned to bus successfully',
          //   'success'
          // );
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: 'Error while assigning students to bus',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.loadingStudents = false;
          this.closeStudentsDialog();
        });
    },
    assignStudentsOrder(item) {
      this.loadAvailableStudents();
      this.selectedBus = item;
      this.selectedStudents = item?.students;
      this.studentsOrderDialog = true;
    },
    closeStudentsOrderDialog() {
      this.studentsOrderDialog = false;
      this.loadingStudents = false;
      this.availableStudents = [];
      this.selectedStudents = [];
    },
    orderStudentsToBus() {
      this.loadingStudents = true;
      axios
        .post(`/buses/order-students`, {
          bus_id: this.selectedBus.id,
          students_ids: this.selectedStudents,
        })
        .then(() => {
          this.loadBuses();
          this.$notify({
            title: this.$t('messages.success'),
            text: 'Students order saved',
            type: 'success',
          });
          // this.$swal('Success', 'Students order saved successfully', 'success');
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: 'Error while changing students order',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.loadingStudents = false;
          this.closeStudentsOrderDialog();
        });
    },
  },
};
</script>

<style lang="scss">
/* Mobile table cell wrap */
.v-data-table__mobile-row {
  align-items: flex-start !important;
  padding: 6px 16px !important;
}
.v-data-table__mobile-row__cell {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  white-space: normal !important;
  max-width: 55vw;
  text-align: right;
}
/* Driver chips wrap on mobile */
@media (max-width: 600px) {
  .v-data-table__mobile-row__cell > div {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }
  .v-data-table__mobile-row__cell .v-chip {
    max-width: 55vw !important;
    height: auto !important;
    white-space: normal !important;
  }
  .v-data-table__mobile-row__cell .v-chip .v-chip__content {
    white-space: normal !important;
    word-break: break-all !important;
  }
}
</style>
